<script>
  export let theme_blog_list;
  export let index;
</script>

<h3><i class="material-icons">linked_camera</i> 文章推薦</h3>
<div class="content_listBox blogBox">
  {#if theme_blog_list.length == 0}
    <p>loading....</p>
  {:else}
    {#each theme_blog_list[index] as blog}
      <div class="content_list">
        <a href={blog.blog_link} target="_blank">
          <div class="imgBox">
            <div class="photo"><img src={blog.blog_photo} alt="" /></div>
          </div>
          <div class="txtBox">
            <div class="title">{blog.blog_title}</div>
          </div>
        </a>
      </div>
    {/each}
  {/if}
</div>
